import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=37e5bfbc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=37e5bfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5bfbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e5bfbc')) {
      api.createRecord('37e5bfbc', component.options)
    } else {
      api.reload('37e5bfbc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=37e5bfbc&scoped=true&", function () {
      api.rerender('37e5bfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wN9idVRvSwg0/JS/comp/DocBox.vue"
export default component.exports